<template>
  <TableActionButton
    :label="$t('sampleProgress.files.download')"
    button-icon="fas fa-download"
    button-color="green"
    :disabled="downloading"
    :click-function="download"
  />
</template>

<script>
import fileSaver from 'file-saver';
import { sampleProgressApi } from '@/api';
import TableActionButton from '@/components/TableActionButton.vue';

/**
 * Downloads one file box attachment (the current revision of a chain), always through the MyLab
 * proxy: the file is MyLab's own copy, never fetched from where the publisher keeps it.
 */
export default {
  name: 'ProgressFileDownload',
  components: {
    TableActionButton,
  },
  props: {
    sampleId: {
      type: Number,
      required: true,
    },
    // A row of the file box or of a chain's revisions.
    file: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      downloading: false,
    };
  },
  methods: {
    async download() {
      this.downloading = true;
      try {
        const { sampleId, file } = this;
        const { data } = await sampleProgressApi.downloadFile(sampleId, file.attachmentId);
        // The stored name as is: the one in Content-Disposition is reduced to latin1.
        fileSaver.saveAs(data, file.displayName);
      } catch (error) {
        this.$notify({
          showClose: true,
          type: 'error',
          message: error.response?.data?.error?.message || this.$t('sampleProgress.files.downloadError'),
        });
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>
